<template>
    <navbar />
    <section class="about">
        <div class="container">
            <h4 class="title">{{ $t("about") }}</h4>
            <img :src="about.image" alt="halim">
            <a :href="about.link" download target="_blank" class="btn PrimaryButton">{{ $t("download_cv") }}<i class="fa-regular fa-circle-down"></i></a>
            <p class="text" v-html="about.full_description"></p>
        </div>
    </section>
</template>

<script>
import navbar from '@/components/layout/navbar.vue'
import axios from 'axios'

export default {
    name: "about-page",
    data() {
        return {
            about: {}
        }
    },
    methods: {
        fetchAbout() {
            axios
              .get("/fetch_about")
              .then(({ data }) => {
                this.about = data.data;
                // console.log(this.meals , "meals");
            })
            .catch((error) => {
                return error
            });
        },
    },
    components: {
        navbar
    },
    created() {
        this.fetchAbout();
    }
}
</script>

<style>

</style>